export class SavedSearchConfig {

    public searchId: number;
    public searchName: string;
    public searchNameOrig: string;

}





// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/search/models/saved-search-config.ts